export const de = {
  header: {
    home: "Startseite",
    about: "Über uns",
    mission: "Mission",
    program: "Stufen",
    instructor: "Instruktor",
    faq: "FAQ",
    gallery: "Galerie",
    contact: "Kontakt"
  },
  hero: {
    title: "Jeet Kune Do in Zürich",
    subtitle: "Entwickle praktische Selbstverteidigungsfähigkeiten, verbessere deine Fitness und entfalte dein volles Potenzial.",
    bookTrial: "Kostenloses Probetraining buchen",
    viewSchedule: "Stundenplan ansehen"
  },
  mission: {
    title: "Unsere Mission",
    intro: "Wir führen dich vom Chaos zur Kontrolle – ohne dich zu jemandem zu machen, der du nicht bist.",
    description: "J.K.D. Functional Defense wurde mit einem Ziel gegründet: normalen Menschen zu helfen, ruhig, klar und kontrolliert zu bleiben, wenn das Leben chaotisch wird.",
    focusTitle: "Wir konzentrieren uns auf:",
    focusList: [
      "Keine Panik aufkommen lassen",
      "Ordnung im Chaos bewahren",
      "Deinen Körper mit Absicht einsetzen, nicht mit Aggression",
      "Innere und äußere Stärke aufbauen",
      "Schritt für Schritt wachsen, ohne Druck"
    ],
    cardTitle: "Keine Gewalt. Kein Ego. Keine unrealistischen Techniken.",
    cardText: "Nur Funktionalität, Bewusstsein und echte Sicherheit."
  },
  about: {
    title: "Über Jeet Kune Do",
    intro: "Jeet Kune Do, „Der Weg der abfangenden Faust“, ist die von Bruce Lee in den 1960er-Jahren entwickelte Kampfkunst-Philosophie. Sie legt den Schwerpunkt auf Praktikabilität, Anpassungsfähigkeit und Effizienz – alles wird entfernt, was in realen Situationen nicht funktioniert. JKD ist kein festes Stil-System. Es ist ein flexibler Ansatz, der sich mit dir weiterentwickelt und dich dazu ermutigt, das Nützliche aufzunehmen, das Unnütze zu verwerfen und deine eigenen Stärken auszudrücken.",
    principlesTitle: "Die drei Grundprinzipien",
    principles: [
      { title: "Einfachheit", text: "Das Notwendige tun und das Unnötige eliminieren." },
      { title: "Direktheit", text: "Die kürzeste Verbindung zwischen zwei Punkten ist eine Gerade." },
      { title: "Freiheit", text: "Keinen Weg als Weg, keine Grenze als Grenze." }
    ]
  },
  program: {
    title: "JKD Progressionspfad",
    sections: {
      psychologicalgoals: "Psychologische Ziele",
      technicalskills: "Technische Fähigkeiten",
      scenarios: "Szenarien",
      assessment: "Bewertung",
      requirements: "Anforderungen"
    },
    levels: [
      {
        title: "Stufe 1 (Grundlagen)",
        color: "var(--white-gray)",
        slogan: "Zuerst lernst du, nicht in Panik zu geraten.",
        psychologicalgoals: [
          "Angstbewältigung",
          "Atmungskontrolle",
          "Raumbewusstsein",
          "Instinktive Schutzhaltung"
        ],
        technicalskills: [
          "Grundlegende Beinarbeit (Vorwärts, Rückwärts, Seitwärts)",
          "Natürliche Haltung (nicht kämpferisch, nicht aggressiv)",
          "Instinktive Blocks, Deckung, „Fence“-Position",
          "Distanzverständnis: sicher – kritisch – Gefahrenzone"
        ],
        scenarios: [
          "Aggressive Annäherung",
          "Eskalierender Streit",
          "Vermeiden, in eine Ecke gedrängt zu werden"
        ],
        assessment: [
          "Ruhe unter Druck",
          "Korrekte Haltung",
          "Gleichgewicht in Bewegung",
          "Erkennen von Distanz und Timing"
        ]
      },
      {
        title: "Stufe 2 (Kontaktmanagement)",
        color: "#eeee64ff",
        slogan: "Zuerst vermeidest du, dann kontrollierst du. Erst danach reagierst du.",
        psychologicalgoals: [
          "Erkennen voraggressiver Signale",
          "Sich nicht in die Emotionen des anderen hineinziehen lassen"
        ],
        technicalskills: [
          "Hand-Checking und Kontaktreflexe",
          "Funktionales Trapping (nur was nützlich ist)",
          "Dynamische Paraden",
          "Führungshand + Stop-Hit Konzepte"
        ],
        scenarios: [
          "Stoß gegen die Brust",
          "Greifen am Shirt/Jacke",
          "Konflikt auf sehr kurzer Distanz"
        ],
        assessment: [
          "Ruhe bewahren beim Geschubstwerden",
          "Distanz wahren",
          "Einfache, saubere Reaktionen"
        ]
      },
      {
        title: "Stufe 3 (Flucht & Überleben)",
        color: "#79df79ff",
        slogan: "Zuerst befreist du dich, dann schaffst du Distanz.",
        psychologicalgoals: [
          "Kontrollierte instinktive Reaktion",
          "Nicht einfrieren bei physischem Kontakt"
        ],
        technicalskills: [
          "Befreiung aus Griffen",
          "Verteidigung gegen Würgegriffe",
          "Entkommen aus Haltegriffen und Umklammerungen",
          "Aus dem Clinch kommen"
        ],
        scenarios: [
          "Aggression auf Null-Distanz",
          "Würgen gegen eine Wand",
          "Griff von hinten"
        ],
        assessment: [
          "Geschmeidige Befreiung ohne rohe Kraft",
          "Ständige Bewegung",
          "Sichere Flucht + Distanz schaffen"
        ]
      },
      {
        title: "Stufe 4 (Angewandtes JKD)",
        color: "#2b52efff",
        slogan: "Einfach. Direkt. Unvermeidlich.",
        technicalskills: [
          "Stopp-Kick",
          "Abfangende Faust",
          "Fortgeschrittene Beinarbeit",
          "Ablenkungen, Finten und Winkel",
          "Mobiles Trapping",
          "Schläge auf kurzer Distanz"
        ],
        psychologicalgoals: [
          "Einen klaren Kopf bewahren beim Angreifen",
          "Kontrolle der eigenen Aggression"
        ],
        scenarios: [
          "Schnell vorrückender Angreifer",
          "Weite Schwinger / Haymakers",
          "Plötzliches Schließen der Distanz"
        ],
        assessment: [
          "Einfache Kombinationen",
          "Präzise Stop-Hits",
          "Stabile Haltung und Gleichgewicht"
        ]
      },
      {
        title: "Stufe 5 (Reale Szenarien & Sparring)",
        color: "#000000",
        slogan: "Es ist kein Sport. Es ist die Kontrolle des Chaos.",
        technicalskills: [
          "Themenbasiertes Sparring",
          "Sparring mit wechselnder Distanz",
          "Sparring unter psychologischem Druck"
        ],
        scenarios: [
          "Enge Räume",
          "Raum mit Hindernissen",
          "Sitzende Situationen",
          "Konzepte gegen zwei Angreifer"
        ],
        psychologicalgoals: [
          "Schnelle Entscheidungsfindung",
          "Adrenalinmanagement",
          "Deeskalation unter Stress"
        ],
        assessment: [
          "Vollständiges Szenario",
          "Distanz, Timing, Klarheit",
          "Konfliktvermeidung wenn möglich"
        ]
      },
      {
        title: "Stufe 6 (Instruktor)",
        color: "#e63946",
        slogan: "Führe mit Ethik. Lehre mit Ruhe.",
        requirements: [
          "Volle Beherrschung aller fünf vorherigen Stufen",
          "Exzellente Kommunikation",
          "Fähigkeit, die Sicherheit der Gruppe zu gewährleisten",
          "Kein Ego",
          "Disziplin und Ethik"
        ],
        technicalskills: [
          "Gestaltung von Lektionen",
          "Menschen helfen, die Angst haben",
          "Korrigieren ohne zu demütigen",
          "Erklären von Psychologie und rechtlichen Aspekten",
          "Risikomanagement"
        ],
        assessment: [
          "Leiten einer kompletten Klasse",
          "Präsentation eines Theoriemoduls",
          "Leiten eines Szenarios als Instruktor",
          "Professionelle Feedback-Bewertung"
        ]
      }
    ]
  },
  instructor: {
    title: "Dein Instruktor",
    name: "Michele Piccini",
    role: "Cheftrainer",
    description1: "Michele Piccini ist ein Instruktor mit langjähriger Erfahrung in Kampfkunst und Selbstverteidigung. Sein Stil ist direkt, menschlich und praxisnah.",
    description2: "Seine Stärke liegt darin, komplexe Konzepte in einfache, natürliche und sofort anwendbare Bewegungen zu übersetzen. Er versteht es, jedem ein gutes Gefühl zu geben, besonders Anfängern, und bringt Ruhe und Kontrolle in herausfordernde Situationen.",
    description3: "Sein Hintergrund im medizinischen und akademischen Bereich verleiht ihm eine besondere Sensibilität für Sicherheit, Kommunikation, Stressmanagement und die Unterstützung von Menschen, die Angst oder Unsicherheit erleben.",
    description4: "Bei JKD Functional suchen wir keine Kämpfer. Wir suchen Menschen, die bewusster, stabiler und sicherer werden wollen.",
    description5: "Micheles Methode versucht nicht, dich zu verändern. Sie hilft dir, zur besten und stärksten Version deiner selbst zu werden.",
    credentialsTitle: "Zertifizierungen",
    credentials: ["Zertifizierter JKD Instruktor", "20+ Jahre Erfahrung", "Selbstverteidigungsspezialist"],
    drawer: {
      bioTitle: "Biografie",
      storyTitle: "Meine Geschichte",
      storyText: "Eine Entdeckungsreise durch die Kampfkünste, lernen von den Besten, um die Besten zu lehren.",
      timelineTitle: "Zeitlinie",
      philosophyTitle: "Philosophie",
      philosophyText: "Nimm an, was nützlich ist, lass weg, was unnütz ist, und füge das hinzu, was dein Eigenes ist."
    }
  },
  faq: {
    title: "Häufig gestellte Fragen",
    subtitle: "Alles, was du wissen musst, bevor du deine JKD-Reise beginnst",
    items: [
      {
        question: "Welche Methode unterrichtet ihr bei JKD Functional Defense?",
        answer: {
          intro: "Unsere Methode basiert auf drei Kernkomponenten:",
          list: [
            "Bruce Lees JKD-Prinzipien – Praktische, effiziente Techniken mit Fokus auf Anwendbarkeit in der realen Welt.",
            "Moderne urbane Selbstverteidigung – Szenariobasiertes Training, Verhaltenspsychologie und klare Entscheidungsfindung.",
            "Stressmanagement – Atmung, Ruhe und mentale Kontrolle zur Verbesserung deiner Reaktionen unter Druck."
          ],
          conclusion: [
            "Wir bringen dir nicht nur bei, wie man kämpft.",
            "Wir lehren dich, wie man denkt, vorbeugt und reagiert – innerhalb und außerhalb des Trainingsraums."
          ]
        }
      },
      {
        question: "Brauche ich Vorerfahrung in Kampfkünsten?",
        answer: "Absolut nicht! Wir heißen komplette Anfänger willkommen. Viele unserer besten Schüler haben ohne Erfahrung begonnen. Wir bringen dir alles von Grund auf bei, beginnend mit Grundstellung, Bewegung und Koordination, bevor wir zu komplexeren Techniken übergehen."
      },
      {
        question: "Welche Ausrüstung brauche ich für meine erste Stunde?",
        answer: "Für dein Probetraining bring einfach bequeme Sportkleidung (T-Shirt und Trainingshose oder Shorts), Hallenschuhe und eine Wasserflasche mit. Wir stellen Handschuhe, Pratzen und Schutzausrüstung zur Verfügung. Sobald du dich entscheidest weiterzumachen, empfehlen wir, zumindest eigene Handschuhe, Kopfschutz und einen Zahnschutz zu besorgen."
      },
      {
        question: "In welcher Sprache wird unterrichtet?",
        answer: "Der Unterricht findet hauptsächlich auf Englisch statt. Michele ist italienischer Muttersprachler, und unsere Gruppe umfasst Schüler, die Italienisch, Deutsch, Französisch und andere Sprachen sprechen. Der Kulturmix schafft eine freundliche, internationale Umgebung, in der sich jeder willkommen fühlt."
      },
      {
        question: "Wie buche ich ein kostenloses Probetraining?",
        answer: "Ganz einfach! Fülle <a href=\"https://docs.google.com/forms/d/1UYNWIYzQmMpG-_qwSAGJJ91QxA8dB4VTOehR0GbS8wQ/viewform \" target=\"_blank\">dieses Google-Formular</a> aus. Du kannst auch eine <a href=\"https://wa.me/41764002839\" target=\"_blank\">WhatsApp-Nachricht</a> senden."
      },
      {
        question: "Bietet ihr Privatstunden an?",
        answer: "Ja, Privatstunden sind verfügbar. Du kannst individuelle Trainingseinheiten direkt mit Michele buchen."
      },
      {
        question: "Bietet ihr Teambuilding, Workshops oder spezielle Events an?",
        answer: "Ja, wir organisieren Workshops, Teambuilding-Sitzungen und maßgeschneiderte Events. Bitte fülle <a href=\"https://docs.google.com/forms/d/1Tcx-DYHsgSLb6orpUEuF_0ZKbHCKpx7S3Wypy7V3n-0/viewform \" target=\"_blank\">dieses Google-Formular</a> aus, um einen Workshop anzufragen, und <a href=\"https://docs.google.com/forms/d/1paT10uR_iVN1bUVqnP_lAECLVvv6yVBQHs3YAAMm5CU/viewform  \" target=\"_blank\">dieses</a> für ein Teambuilding-Event."
      },
      {
        question: "Kann Michele in meiner Firma oder an einem anderen Ort unterrichten?",
        answer: "Ja, Michele kann zu Firmen oder externen Orten reisen. Reisen und Training vor Ort sind möglich. Preise auf Anfrage."
      },
      {
        question: "Wie viel kosten die Stunden?",
        answer: {
          list: [
            "Probetraining — Gratis",
            "1 Lektion — CHF 35 (gültig 2 Monate)",
            "5er-Abo — CHF 175 (gültig 2 Monate)",
            "10er-Abo — CHF 320 (gültig 4 Monate)",
            "30er-Abo — CHF 870 (gültig 12 Monate)",
            "Privatlektion — Preis auf Anfrage",
            "Teambuilding-Events — Preis auf Anfrage"
          ]
        }
      },
      {
  question: "Wo befindet sich die Schule?",
  answer: "Die Schule befindet sich an der Kronenstrasse 12, 8006 Zürich, im Erdgeschoss (Stock 0). Manchmal trainieren wir auch im oberen Stockwerk."
}
    ],
    cta: {
      title: "Bereit für dein kostenloses Probetraining?",
      text: "Komm zu einer unverbindlichen Probestunde und entdecke den JKD-Unterschied",
      button: "Kostenloses Probetraining buchen"
    }
  },
  instagram: {
    title: "Folge uns auf Instagram",
    button: "Profil ansehen"
  },
  footer: {
    description: "JKD Functional Defense ist eine moderne Selbstverteidigungsschule in Zürich. Es ist eine sichere, einladende Umgebung für echte Menschen: Studenten, Berufstätige, Anfänger, Männer und Frauen jeden Alters.",
    classesTitle: "Stundenplan",
    days: {
      wednesday: "Mittwoch",
      friday: "Freitag"
    },
    privateLessons: "Privatstunden sind zu verschiedenen Zeiten und an verschiedenen Orten verfügbar.",
    copyright: "© 2025 Mike JKD Evolution. Alle Rechte vorbehalten."
  }
};
